var React = require('react');

function IconEmail (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21 4.5H3A1.5 1.5 0 001.5 6v12A1.5 1.5 0 003 19.5h18a1.5 1.5 0 001.5-1.5V6A1.5 1.5 0 0021 4.5zM19.35 6L12 11.09 4.65 6h14.7zM3 18V6.68l8.57 5.94a.75.75 0 00.86 0L21 6.67V18H3z"}));
}

IconEmail.defaultProps = {"fill":"currentColor","aria-hidden":"true","focusable":"false","viewBox":"0 0 24 24"};

module.exports = IconEmail;

IconEmail.default = IconEmail;
